var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"span3 nbsp"}),_c('div',{staticClass:"span9"},[_c('h3',{staticClass:"cv-section-title"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }